import { InMemoryHeader, InMemoryString, InMemoryInteger } from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function getHeaders(languages, systemColors) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
  ];

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.faq.group_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`Group${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  headers.push(
    new InMemoryHeader({
      title: "headers.faq.group_icon",
      type: new InMemoryString("GroupIcon", {
        getHtml: (item, type) => {
          return `<i class="v-icon notranslate mdi theme--light ${
            item.GroupIcon
          }"></i><span style="margin-left:5px">${item.GroupIcon}</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  headers.push(
    new InMemoryHeader({
      title: "headers.faq.group_icon_color",
      type: new InMemoryString("GroupIconColor", {
        getHtml: (item, type) => {
          if (
            item.GroupIconColor === null ||
            item.GroupIconColor === undefined
          ) {
            return "";
          }
          const keys = Object.keys(systemColors).filter(
            (o) => o.toLowerCase() === item.GroupIconColor.toLowerCase()
          );
          if (keys.length > 0) {
            const index = keys[0];
            return `<div style="background-color:${
              systemColors[index]
            };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
              item.GroupIconColor
            }</span>`;
          }
          return item.GroupIconColor;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  headers.push(
    new InMemoryHeader({
      title: "headers.faq.text_color",
      type: new InMemoryString("TextColor", {
        getHtml: (item, type) => {
          if (item.TextColor === null || item.TextColor === undefined) {
            return "";
          }
          const keys = Object.keys(systemColors).filter(
            (o) => o.toLowerCase() === item.TextColor.toLowerCase()
          );
          if (keys.length > 0) {
            const index = keys[0];
            return `<div style="background-color:${
              systemColors[index]
            };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
              item.TextColor
            }</span>`;
          }
          return `<div style="background-color:${
            item.TextColor
          };width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${
            item.TextColor
          }</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  headers.push(
    new InMemoryHeader({
      title: "headers.member_life_events.category_id",
      type: new InMemoryInteger("CategoryId"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.download_centre.category_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`Category${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "headers.member_life_events.category_image",
      type: new InMemoryString("CategoryImage", {
        getHtml: (item, type) => {
          if (item.CategoryImage === null || item.CategoryImage === undefined) {
            return "";
          }
          return (
            `<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>
            <a href="${item.CategoryImage}" target="_blank">${item.CategoryImage}</a>
            </div>`
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.member_life_events.category_text_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`CategoryText${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "headers.member_life_events.questions",
      type: new InMemoryString("Questions", {
        getString: (item) => {
          console.log(item);
          if (item.Questions === null || item.Questions === undefined) {
            return ""
          }
          return item.Questions.length;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  return headers;
}
export default getHeaders;
